/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Audio_Description_PluginInputs */



/**
* | output |
* | --- |
* | "Audio Description Plugin" |
*
* @param {Team_Manager_Audio_Description_PluginInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_audio_description_plugin = /** @type {((inputs?: Team_Manager_Audio_Description_PluginInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Audio_Description_PluginInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Plug-in de description audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audiobeschreibungs-Plugin")
	if (locale === "it") return /** @type {LocalizedString} */ ("Plugin di descrizione audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Плагин аудиоописания")
	if (locale === "es") return /** @type {LocalizedString} */ ("Complemento de descripción de audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("音频描述插件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオ説明プラグイン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो विवरण प्लगइन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Plugin de descrição de áudio")
	return /** @type {LocalizedString} */ ("Audio Description Plugin")
});